const findScript = (stripeUrl) => {
  const scripts = document.querySelectorAll(`script[src^="${stripeUrl}"]`);

  if (scripts.length > 0) {
    return scripts[0];
  } else {
    return null;
  }
};

const injectScript = (stripeUrl) => {
  const script = document.createElement('script');
  script.src = stripeUrl;

  const headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error(
      'Expected document.body not to be null. Stripe.js requires a <body> element.',
    );
  }

  headOrBody.appendChild(script);

  return script;
};

const loadScript = (stripeUrl) => {
  return new Promise((resolve, reject) => {
    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      const script = findScript(stripeUrl) || injectScript(stripeUrl);

      script.addEventListener('load', () => {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error('Stripe.js not available'));
        }
      });

      script.addEventListener('error', () => {
        reject(new Error('Failed to load Stripe.js'));
      });
    } catch (err) {
      reject(err);
      return;
    }
  });
};

export const loadStripe = ({ stripeApiKey, stripeUrl, stripeAccountId }) => {
  if (typeof window === 'undefined') {
    return null;
  }

  return loadScript(stripeUrl).then((stripe) => stripe(stripeApiKey, { apiVersion: '2022-11-15', stripeAccount: stripeAccountId }));
};
